import { AutoComboColumn, ComboOption, ComboValueMode } from './autoCombo.models';

export const getComboOptionValue = (
  option: ComboOption,
  mode: ComboValueMode,
): number | string | null => {
  if (mode === 'ix') return option.rix;
  if (mode === 'code') return option.shc;
  return option.rid;
};

export const comboOptionMatchesValue = (
  option: ComboOption,
  value: number | string | null,
  mode: ComboValueMode,
): boolean => {
  if (value === null || value === undefined || value === '') return false;
  return String(getComboOptionValue(option, mode)) === String(value);
};

export const defaultAutoComboLabel = (option: ComboOption): string =>
  option.shc && option.nam
    ? `${option.shc} — ${option.nam}`
    : option.nam || option.shc || '';

export const mergeComboOptions = (
  current: ComboOption[],
  incoming: ComboOption[],
): ComboOption[] => {
  const map = new Map<string, ComboOption>();

  [...current, ...incoming].forEach((option) => {
    const key =
      option.rix ||
      (option.rid !== null && option.rid !== undefined ? String(option.rid) : '') ||
      option.shc;

    if (key) map.set(key, option);
  });

  return Array.from(map.values());
};

export const columnTemplate = (columns: AutoComboColumn[]): string =>
  columns.map((column) => {
    if (column.flex) return `minmax(160px, ${column.flex}fr)`;
    if (typeof column.width === 'number') return `${column.width}px`;
    return column.width || 'auto';
  }).join(' ');
